import axios from './axios'
import qs from 'qs'

function query(params) {
    return {
        params: params,
        paramsSerializer: value => qs.stringify(value, {encode: false})
    };
}

function service(endpoint) {

    function fetchComplianceDetails(id, params) {
        return axios.get(`${endpoint}/therapies/${id}/compliance-details`, query(params)).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function fetchCompliance(id) {
        return axios.get(`${endpoint}/therapies/${id}/compliance`).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function fetchPhases(id) {
        return axios.get(`${endpoint}/therapies/${id}/phases`).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function fetchForPatient(pseudonymId, params) {
        return axios.get(`${endpoint}/patients/${pseudonymId}/therapies`, query(params)).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function transition(id, action, data) {
        return axios.post(`${endpoint}/therapies/${id}/${action}`, data).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    return {
        fetchComplianceDetails,
        fetchCompliance,
        fetchPhases,
        fetchForPatient,
        transition
    }
}

export default service
